<template>
    <div  id="page-offset">
        <div class="container">
        <button
            v-on:click.prevent="openMobileFilters = !openMobileFilters"
            class="cms-content-our-range-filter__mobile-filter-btn  select-model__filter-button  cms-content-our-range-filter__button btn btn--full-width"
            :class="{ 'cms-content-our-range-filter__button--active  select-model__filter-button--active': openMobileFilters }"
        >
            Filter
        </button>
            <div
            class="cms-content-our-range-filter__group"
            :class="{ 'cms-content-our-range-filter__group--open': openMobileFilters }"
            >
                <select-dropdown
                    option-key="brand"
                    id="brandSelect"
                    :event="{ category: 'Electric Model Search', label: 'Brand Clicked' }"
                >
                    Brand
                </select-dropdown>
                <select-dropdown
                    option-key="model"
                    id="modelSelect"
                    :event="{ category: 'Electric Model Search', label: 'Model Clicked' }"
                >
                    Model
                </select-dropdown>
                <select-dropdown
                    option-key="bodystyle"
                    id="bodySelect"
                    :event="{ category: 'Electric Model Search', label: 'Body Type Clicked' }"
                >
                    Body type
                </select-dropdown>

                <button
                    v-on:click="openMobileFilters = false"
                    class="cms-content-our-range-filter__filter-close btn btn--primary btn--full-width"
                >
                    Search
                </button>
            </div>
            <div>
                <div class="card__inner">
                    <ul class="select-model__grid" >
                        <li class="select-model__grid--item" v-for="model in filteredVehicles" :key="model.id">
                            <picture>
                                <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp" />
                                <img class="img-responsive select-model__image" :src="model.image" :alt="model.model_title" />
                            </picture>
                            <div class="select-model__grid--inner">
                                <p class="select-model__title capitalise">{{ model.model_title.replace("Citroen", "Citroën") }}</p>
                                <div class="select-model__grid--spec-box">
                                    <KeySpecItem svg="#svg-vehicle-type-default" label="" :value="model.friendly_bodystyle" />
                                    <KeySpecItem svg="#svg-ev-range" label="" :value="max_ev_range(model)" />
                                </div>
                                <div class="select-model__grid--button">
                                    <button @click="select(model)" class="btn btn--primary btn--full-width btn--centered">Book now</button>
                                    <a :href="model.route" class="link link--is-button link--has-icon link--secondary link--centered">Discover More</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="select-model__load-more">
                <button type="button" class=" btn btn--primary-inverted " @click="ToggleShowMoreVehicles" v-if="showLoadMoreLink">SHOW MORE</button>
                <button type="button" class=" btn btn--primary-inverted " @click="ToggleShowLessVehicles" v-else-if="showLessLink">SHOW LESS</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SelectDropdown from "../SelectDropdown.vue"
import KeySpecItem from "../../../../used-vue/components/KeySpecItem.vue";
import EventObject from "../../../../modules/tracking/EventObject";
import { MatchHeight } from "js-match-height";
import NumberFormat from "../../../../used-vue/api/NumberFormat"


export default {
    components: {
        NumberFormat,
        KeySpecItem,
        SelectDropdown,
    },
    data() {
        return {
            openMobileFilters: false,
            error: false,
            googleClass: null,
            autocomplete: null,
            newModels: [],
            modelsToShow: 8,
            baseModelsToShow:8,
            showMoreVehicles: true,
        };
    },
    computed: {
        ...mapState([
            'vehicles',
            'loadingVehicles',
            'availableOptions',
            'selectedOptions',
            'modelPage',
            'scrollPosition'
        ]),
        ...mapGetters(["currentStep" ]),

        haveMinimumData() {
            if (this.fuelChoice == '') {
                return false;
            }
            if (this.transmissionChoice == '') {
                return false;
            }
            return true;
        },
        filteredVehicles(){
            return this.vehicles.slice(0, this.modelsToShow);
        },
        showLoadMoreLink() {
            return  this.filteredVehicles.length < this.$store.state.vehicles.length;
        },

        showLessLink() {
            if(this.loadingVehicles === false){
                if(this.vehicles.length === this.baseModelsToShow){
                    return false
                }
                if(this.filteredVehicles.length === this.vehicles.length){
                    return true;
                }
            }
        },
    },
    methods: {
        select(model) {
            this.$store.commit("setSelectedModel", model);
            this.getPositionAndSave();
            this.$store.dispatch("navigatorStep", this.currentStep.next);
        },
        ToggleShowMoreVehicles() {
            this.modelsToShow += 4;
            this.matchHeight()
        },
        ToggleShowLessVehicles() {
            this.modelsToShow = 4;
        },
        max_ev_range(vehicle) {
            if (vehicle.max_ev_range == null || vehicle.max_ev_range <= 0) {
                if (vehicle.hybrid_mpg_max != null) {
                    return NumberFormat( vehicle.hybrid_mpg_max)  + ' mile range';
                }

                if(vehicle.hybrid_mpg_min != null) {
                    return NumberFormat(vehicle.hybrid_mpg_min) + ' mile range';
                }

                if (vehicle.mpg_combined !== null){
                    return NumberFormat(vehicle.mpg_combined) + ' mile range';
                }

                return '-';
            }

            return NumberFormat(vehicle.max_ev_range, 0) + ' mile range';
        },
        matchHeight(){
            new MatchHeight(".select-model__title .select-model__grid--button");
        },
        getPositionAndSave() {
            const targetDiv = document.getElementById('page-offset');
            const rect = targetDiv.getBoundingClientRect();
            const position = rect.top + window.scrollY - 50;
            this.$store.commit('savePosition', position);
        }
    },
    created() {
        this.$store.dispatch("getOptionsAndVehicles");
    },
    mounted() {
        this.$nextTick(() => {
            this.getPositionAndSave()
            this.matchHeight()
            if (this.modelPage === true) {
                new EventObject("Electric Car - Test Drive Form", "Revisit", "Model Page").dispatch();
            } else {
                new EventObject("Electric Car - Test Drive Form", "Visited", "Model Page").dispatch();
                this.$store.commit("setModelPage", true);
            }
        });
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/electric-test-drive/steps/ModelSelect.vue